import { Record } from 'immutable';
import MeetingsLink from 'MeetingsBase/models/MeetingsLink';
import LinkAssociatedSettings from 'MeetingsAdmin/models/LinkAssociatedSettings';
import LinkMetadata from 'MeetingsAdmin/models/LinkMetadata';
const LinkBeingEditedRecord = Record({
  staged: new MeetingsLink(),
  linkAssociatedSettings: new LinkAssociatedSettings(),
  metadata: new LinkMetadata()
}, 'LinkBeingEdited');
export default LinkBeingEditedRecord;